import { useNavigate } from 'react-router';
import { ROUTES } from '../App';

export const useSubmissionUtils = () => {
  const navigate = useNavigate();

  /**
   *
   * @param {string} errorMessage1
   * @param {string} errorMessage2
   * @param {string} title
   * @param {string} icon
   */
  const pushError = (errorMessage1, errorMessage2, title, icon) => {
    navigate(ROUTES.ERROR_MESSAGE, {
      state: {
        title,
        icon,
        errorMessage1,
        errorMessage2,
      },
    });
  };

  /**
   *
   * @param {string | number} evalId
   * @param {string} title
   * @param {string} email
   * @param {string} pdfDownloadLink
   */
  const showSuccessSubmissionWithNoAccount = (evalId, title, email, pdfDownloadLink = '') => {
    const stateData = {
      restoreKey: `success:no_acc:${evalId}:${email}`,
      title,
      email,
      pdfDownloadLink,
    };
    localStorage.setItem(stateData.restoreKey, JSON.stringify(stateData));
    navigate(ROUTES.SUCCESS_WITHOUT_ACC, {
      state: stateData,
    });
  };

  /**
   *
   * @param {string | number} evalId
   * @param {string} title
   * @param {string} action
   * @param {string} pdfDownloadLink
   */
  const showSuccessSubmissionWithAccount = (evalId, title, action, pdfDownloadLink = '') => {
    const stateData = {
      restoreKey: `success:has_acc:${evalId}:${action}`,
      title,
      action,
      pdfDownloadLink,
    };
    localStorage.setItem(stateData.restoreKey, JSON.stringify(stateData));
    navigate(ROUTES.SUCCESS_WITH_ACC, {
      state: stateData,
    });
  };

  /**
   *
   * @param {string | number} evalId
   * @param {string} title
   * @param {string} applicantFirstName
   * @param {string} applicantLastName
   * @param {string} formName
   * @param {string} evalType
   * @param {boolean} hasAccount
   * @param {boolean} isResueActive
   * @param {string} pdfDownloadLink
   */
  const showSuccessSubmissionAndReuseGuestAccess = (
    evalId,
    title,
    applicantFirstName,
    applicantLastName,
    formName,
    evalType,
    hasAccount,
    isResueActive,
    pdfDownloadLink = ''
  ) => {
    const stateData = {
      restoreKey: `success:reuse:${hasAccount ? 'has_acc' : 'no_acc'}:${evalId}`,
      title,
      applicantFirstName,
      applicantLastName,
      formName,
      evalType,
      hasAccount,
      pdfDownloadLink,
      isResueActive,
    };
    localStorage.setItem(stateData.restoreKey, JSON.stringify(stateData));
    navigate(ROUTES.SUCCESS_AND_REUSE, {
      state: stateData,
    });
  };

  return {
    pushError,
    showSuccessSubmissionWithNoAccount,
    showSuccessSubmissionWithAccount,
    showSuccessSubmissionAndReuseGuestAccess,
  };
};

export default useSubmissionUtils;
